// import { NavLink } from "react-router-dom";
// import React from "react";
// import styled from "styled-components";
// import Navbar from "./Navbar";

// // Main container for the Header section
// const MainHeader = styled.header`
//   width: 100%;
//   height: 70px;
//   background-color: #0d253f; /* Changed color */
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   padding: 0 2rem;
//   position: fixed;
//   top: 0;
//   left: 0;
//   z-index: 10;
// `;

// const MainContainer = styled.div`
//   margin: 0;
//   padding: 0;
//   box-sizing: border-box;
//   width: 100%;
//   padding-top: 70px;
// `;

// const NavHeader = styled.h1`
//   font-size: 30px;
//   color: #ffffffff;
//   text-align: center;
//   background: linear-gradient(to right, #1f6feb, #0d253f); /* Changed gradient */
//   padding: 20px;
//   border-radius: 10px;
//   margin: 0;
//   transition: all 0.3s ease-in-out;

//   &:hover {
//     background: linear-gradient(to right, #0056b3, #0d253f);
//     cursor: pointer;
//   }

//   @media (max-width: 768px) {
//     font-size: 24px;
//     padding: 15px;
//   }

//   @media (max-width: 480px) {
//     font-size: 20px;
//     padding: 10px;
//   }
// `;

// // Styled link that wraps the header text
// const StyledLink = styled(NavLink)`
//   text-decoration: none;
// `;

// const Header = () => {
//   return (
//     <>
//       <MainContainer>
//         <MainHeader>
//           <StyledLink to="/">
//             <NavHeader>ClicknfindStore</NavHeader>
//           </StyledLink>
//           <Navbar />
//         </MainHeader>
//       </MainContainer>
//     </>
//   );
// };

// export default Header;


import { NavLink } from "react-router-dom";
import React from "react";
import styled from "styled-components";
import { FaWhatsapp } from "react-icons/fa";
import Navbar from "./Navbar";
import { MdStorefront } from "react-icons/md";

// WhatsApp Icon Wrapper (Responsive)
const WhatsAppIconWrapper = styled.a`
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #25D366;
  color: white;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  z-index: 100;
  box-shadow: 0 4px 6px rgba(0,0,0,0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 10px rgba(0,0,0,0.3);
    cursor: pointer;
  }

  @media (max-width: 768px) {
    width: 50px;
    height: 50px;
    font-size: 26px;
    bottom: 15px;
    right: 15px;
  }

  @media (max-width: 480px) {
    width: 45px;
    height: 45px;
    font-size: 22px;
    bottom: 200px;
    right: 10px;
  }
`;

// Shopping Cart Icon next to header text
const CartIcon = styled(MdStorefront)`
  margin-right: 8px;
  font-size: 38px;
  color: #f7c009ff;
  cursor: pointer;
  transition: color 0.3s ease, transform 0.3s ease;

  &:hover {
    color: #eb261fff;
    transform: scale(1.1);
  }

  @media (max-width: 768px) {
    font-size: 24px;
    margin-left: 10px;
  }

  @media (max-width: 480px) {
    font-size: 30px;
    margin-left: 5px;
  }
`;

// Main container for the Header section
const MainHeader = styled.header`
  width: 100%;
  height: 70px;
  background-color: #0d253f;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 2rem;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
`;

const MainContainer = styled.div`
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  width: 100%;
  padding-top: 70px;
`;

const NavHeader = styled.h1`
  font-size: 30px;
  color: #ffffff;
  text-align: center;
  display: flex;
  align-items: center;
  background: linear-gradient(to right, #1f6feb, #0d253f);
  padding: 20px;
  border-radius: 10px;
  margin: 0;
  transition: all 0.3s ease-in-out;

  &:hover {
    background: linear-gradient(to right, #0056b3, #0d253f);
    cursor: pointer;
  }

  @media (max-width: 768px) {
    font-size: 24px;
    padding: 15px;
  }

  @media (max-width: 480px) {
    font-size: 20px;
    padding: 10px;
  }
`;

const StyledLink = styled(NavLink)`
  text-decoration: none;
  display: flex;
  align-items: center;
`;

const Header = () => {
  return (
    <>
      <MainContainer>
        <MainHeader>
          <StyledLink to="/">
            <NavHeader>
              <CartIcon /> {/* Shopping cart icon */}
              Ramia Brand
            </NavHeader>
          </StyledLink>
          <Navbar />
        </MainHeader>
      </MainContainer>

      {/* WhatsApp Icon */}
      
    </>
  );
};

export default Header;


